<template>
    <div class="field">
        <label class="field-label field-label-toggle" :for="plan.id">
            <p stack-m>{{ plan.name | truncate({limit: 26, dots: true}) }}</p>
            <p v-for="(price, priceIdx) in pricing" :key="priceIdx">{{ price }}</p>
        </label>
        <input type="radio"
               class="field-radio"
               :checked="selected"
               :id="plan.id"
               :name="plan.id"
               :value="plan.id"
               @change="update($event)"/>
        <span class="field-radio-style">
            <v-icon icon="radio-checkmark"></v-icon>
        </span>
    </div>
</template>

<script>
    import PlanModel from '@/common/models/plan-model';
    import vIcon from '@/components/form/v-icon';
    import PricingRenderer from '@/modules/plans/pricing-renderer';

    export default {
        name: 'pricing-plan-radio',
        props: {
            plan: {
                type: PlanModel,
                default: null,
            },
            selected: {
                type: Boolean,
                default: false,
            },
            unitLabel: {
                type: String,
                default: 'Unit',
            },
        },
        components: {
            vIcon,
        },
        computed: {
            pricing() {
                return PricingRenderer.render(
                    this.plan.currency,
                    this.plan.pricing,
                    this.plan.recurringInterval,
                    this.unitLabel,
                );
            },
        },
        methods: {
            update() {
                this.$emit('input', this.plan);
            },
        },
    };
</script>
